import {
  Download1Stroke,
  PrinterStroke,
  RefreshCircle1ClockwiseStroke,
  Search1Stroke,
  SignPostLeftStroke
} from '@lineiconshq/free-icons';
import { AritoActionBar, AritoActionButton, AritoIcon, AritoMenuButton } from '@/components/custom/erp';
import { getStatusLabel } from '../cols-definition';
import { formatDate } from '@/lib/formatUtils';
import { SearchFormValues } from '../schema';

/**
 * Props for the ActionBar component
 */
interface ActionBarProps {
  isViewDisabled?: boolean;
  onSearchClick?: () => void;
  onPrintClick?: () => void;
  onRefreshClick?: () => void;
  onFixedColumnsClick?: () => void;
  onExportClick?: () => void;
  onEditPrintClick?: () => void;
  searchParams?: SearchFormValues;
}

/**
 * ActionBar component for the Balance Sheet by Unit page
 */
const ActionBar: React.FC<ActionBarProps> = ({
  isViewDisabled = false,
  onSearchClick,
  onPrintClick,
  onFixedColumnsClick,
  onRefreshClick,
  onExportClick,
  onEditPrintClick,
  searchParams
}) => (
  <AritoActionBar
    titleComponent={
      <div>
        <h1 className='text-xl font-bold'>Báo cáo tình trạng đề nghị chi</h1>
        <span className='flex items-center justify-start text-xs font-semibold text-gray-500'>
          <div className='mr-2 size-2 rounded-full bg-red-500' />
          Từ ngày {formatDate(searchParams?.ngay_ct1)} đến ngày {formatDate(searchParams?.ngay_ct2)}, Trạng thái:{' '}
          {getStatusLabel(searchParams?.status || '10')}
        </span>
      </div>
    }
  >
    {onSearchClick && <AritoActionButton title='Tìm kiếm' icon={Search1Stroke} onClick={onSearchClick} />}
    {onPrintClick && (
      <AritoActionButton title='In ấn' icon={PrinterStroke} onClick={onPrintClick} disabled={isViewDisabled} />
    )}
    {onRefreshClick && (
      <AritoActionButton
        title='Refresh'
        icon={RefreshCircle1ClockwiseStroke}
        onClick={onRefreshClick}
        disabled={isViewDisabled}
      />
    )}
    {onFixedColumnsClick && (
      <AritoActionButton
        title='Cố định cột'
        icon={SignPostLeftStroke}
        onClick={onFixedColumnsClick}
        disabled={isViewDisabled}
      />
    )}
    {onExportClick && (
      <AritoActionButton
        title='Kết xuất dữ liệu'
        icon={Download1Stroke}
        onClick={onExportClick}
        disabled={isViewDisabled}
      />
    )}

    <AritoMenuButton
      items={[
        {
          title: 'Chỉnh sửa mẫu in',
          icon: <AritoIcon icon={864} />,
          onClick: onEditPrintClick,
          group: 0
        }
      ]}
    />
  </AritoActionBar>
);

export default ActionBar;
